// extracted by mini-css-extract-plugin
export var button = "button-module--button--3XlGY";
export var button_loading = "button-module--button_loading--LXzYC";
export var spin = "button-module--spin--xEIOx";
export var button_primary = "button-module--button_primary--btSDs";
export var button_text = "button-module--button_text--HTBFh";
export var button_gradient = "button-module--button_gradient--uqH7L";
export var button_active = "button-module--button_active--+X7cC";
export var button__icon = "button-module--button__icon--rjW1O";
export var button__icon_right = "button-module--button__icon_right--CUPzS";